// Module
var code = "<p class=\"circle\">2</p> <p>Sign in using your username and password.</p> ";
// Exports
export default code;